import z from 'zod';

export const AdditionalTermsFormSchema = z.object({
  id: z.number().optional(),
  msaasListingId: z.number().optional(),
  listingId: z.number().optional(),
  bonusesTxt: z.string().optional().nullable(),
  adminCostsTxt: z.string().optional().nullable(),
  infrastructureTxt: z.string().optional().nullable(),
  extraTxt: z.string().optional().nullable(),
});

export type AdditionalTermsFormValues = z.infer<typeof AdditionalTermsFormSchema>;
